module.exports = __webpack_public_path__ + "media/images/guide/image1-7bf095a3a64867b043a53793a22b6b49.png";